import request from "../utils/fetch";
//摄像头列表
export function list(data) {
  return request({
    url: "/public/customer/camera/enterprise/pc/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

//摄像头详情
export function detail(data) {
  return request({
    url: "/public/customer/camera/get/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

//摄像头新增
export function add(data) {
  return request({
    url: "/public/customer/camera/binding",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

//解绑
export function del(data) {
  return request({
    url: "/public/customer/camera/unbinding",
    method: "DELETE",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
